<template>
  <div class="overall-situation" v-loading="fullscreenLoading">
    <div class="situation">
      <div class="topBox">
        <span class="topTitle">作品管理</span>
      </div>
      <el-row :gutter="20" class="status" style="paddingLeft: 0; paddingRight: 0;margin-top: 16px;margin-bottom: 16px;">
        <el-col :span="5.5">
          <label>作品名称：</label>
          <el-input
            style='width: 200px'
            v-model="query.worksName"
            @change="getData"
            clearable
            placeholder="请输入作品名称"
          ></el-input>
        </el-col>
        <el-col :span="5.5">
          <label>登记状态：</label>
          <el-select
            v-model="query.lockStatus"
            placeholder="请选择"
            clearable
            @change="getData"
          >
            <el-option
              v-for="item in lockStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-button size="medium" type="primary" @click="setPass" style='float: right'>设置调档密码</el-button>
      </el-row>
      <el-table
        :data="tableData"
        style="width: 100% margin-left:50px">
        <el-table-column
          prop="worksName"
          label="作品名称"
          >
        </el-table-column>
        <el-table-column label="权利取得方式">
          <template slot-scope="scope">
            <span v-if="scope.row.rightsGet == 0">原始</span>
            <span v-else-if="scope.row.rightsGet == 1">有偿转让</span>
            <span v-else-if="scope.row.rightsGet == 2">继承</span>
            <span v-else-if="scope.row.rightsGet == 3">承受</span>
            <span v-else-if="scope.row.rightsGet == 4">无偿赠与</span>
            <span v-else-if="scope.row.rightsGet == 7">法人或者其他组织分立</span>
            <span v-else-if="scope.row.rightsGet == 8">法人或者其他组织合并</span>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="日期"
          >
        </el-table-column>
        <el-table-column label="登记状态" align="center">
          <template slot-scope="scope">
            <template v-for="(item,index) in lockStatusList">
              <div class="statesBox" :key="index" v-if="scope.row.lockStatus == item.value">
                <div><i :class="[item.class,'states']"></i>{{item.label}}</div>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text"  @click="detailed(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="query.currentPage"
        :page-sizes="[15, 30, 50, 100]"
        :page-size.sync="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      title="设置调档密码"
      :visible.sync="dialogVisible"
      width="480px"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <p style='font-size: 14px;color: #666666;margin-bottom: 40px'>请设置作品存证数据的调档密码，设置完成后，可以在版权局作品登记系统中，一键调取作品存证数据，快捷版权登记。</p>
      <div class='area'>
        <el-input v-if='showPass' style='width: 260px;' placeholder="请输入调档密码" :disabled='!showPass' v-model='password'></el-input>
        <p v-if='showPass' class='confirm' @click='setPassword'>确认</p>
        <span v-if='!showPass' style="border: 1px solid #EEEEEE;">{{password}}</span>
        <i v-if='!showPass' class='icon' :class="watchPass?'open':'close'" @click="changePass"></i>
        <p v-if='!showPass' class='confirm' @click='changeStatus'>修改</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCopyrightList } from "@/api/index";
export default {
  data() {
    return {
      file_url:'https://files.wespace.cn',
      fullscreenLoading: false,
      dialogVisible: false,
      tableData: [],//注册列表
      lockStatus: [
        {
          label: '未调档',
          value: '1',
          class: 'statesConduct'
        },
        // {
        //   label: '调档中',
        //   value: '2',
        //   class: 'statesConduct'
        // },
        {
          label: '已调档',
          value: '2',
          class: 'statesAdopt'
        },
        {
          label: '登记完成',
          value: '5',
          class: 'statesAdopt'
        }
      ],
      lockStatusList: [
        {
          label: '未调取 ',
          value: '1',
          class: 'statesConduct'
        },
        {
          label: '已调档',
          value: '2',
          class: 'statesAdopt'
        },
        {
          label: '已调档',
          value: '3',
          class: 'statesAdopt'
        },
        {
          label: '登记完成',
          value: '5',
          class: 'statesAdopt'
        }
      ],
      query:{
        currentPage:1,
        pageSize:15,
        worksName: '',
        lockStatus: ''
      },
      total:0,
      userData: {},
      user: {},
      showPass: false,
      pass: '',
      password: '',
      watchPass: false
    }
  },
  mounted() {
    this.userData = JSON.parse(sessionStorage.getItem('usnInfo'))
    this.user = this.$store.state.userData
    this.getList()
    this.getStatus()
  },
  methods:{
    setPass(){
      this.dialogVisible = true
    },
    getStatus() {
      this.fullscreenLoading = true
      let fd = new FormData();
      fd.append('usn', this.user.usn)
      fd.append('tenantId', 'wespace')
      this.$axios.post('https://verify.wespace.cn/gov/queryRetrievePassword', fd).then(res=>{
        this.fullscreenLoading = false
        if (res.data.code == 200) {
          this.showPass = res.data.data.passwordStatus < 2
          this.pass = res.data.data.password || ''
          this.password = this.change(this.pass)
        } else {
          this.$message(res.data.message)
        }
      }).catch(err=>{
        this.fullscreenLoading = false
        console.log(err)
      });
    },
    change(num){
      var reg = /(.*)(.)$/;
      let str = String(num).replace(reg,function(a,b,c){
        return a.replace(/./g,"*");
      })
      return str
    },
    changePass(){
      this.watchPass = !this.watchPass
      if (!this.watchPass) {
        this.password = this.change(this.pass)
      } else {
        this.password = this.pass
      }
    },
    changeStatus(){
      this.showPass = !this.showPass
      this.password = this.pass
    },
    setPassword(){
      if (!this.password.trim()){
        this.$message('请输入调档密码')
        return false
      }
      if (this.password.trim().length < 6){
        this.$message('调档密码不得少于6位')
        return false
      }
      if (this.user.identityAuthentication != '2') {
        this.$message('请先完成实名认证！')
        return false
      }
      let fd = new FormData();
      fd.append('usn', this.user.usn)
      let idCardNo = this.user.identityCard.filter(val => (val.cardType == 1 || val.cardType == '3'))[0].idCardNo
      fd.append('cardNo', idCardNo || '')
      fd.append('tenantId', 'wespace')
      fd.append('password', this.password.trim())
      this.$axios.post('https://verify.wespace.cn/gov/setupRetrievePassword', fd).then(res=>{
        this.fullscreenLoading = false
        if (res.data.code == 200) {
          this.$message.success('设置成功')
          this.getStatus()
          this.dialogVisible = false
        } else {
          this.$message(res.data.message)
        }
      }).catch(err=>{
        this.fullscreenLoading = false
        console.log(err)
      });
    },
    getData(){
      this.query.currentPage = 1
      this.getList()
    },
    //列表
    getList() {
      this.fullscreenLoading = true
      if (!(this.userData.identityAuthentication == '2')) {
        this.$message('请先完成实名认证！')
        this.fullscreenLoading = false
        return false
      }
      let info = this.$store.state.userData
      let idCardNo = info.identityCard.filter(val => (val.cardType == 1 || val.cardType == 3))[0]
      let fd = new FormData();
      fd.append('worksName', this.query.worksName)
      fd.append('lockStatus', this.query.lockStatus)
      // fd.append('cardNo', '15042619980525522X')
      fd.append('tenantId', 'wespace')
      fd.append('cardNo', (idCardNo && idCardNo.idCardNo) || '')
      fd.append('currentPage', this.query.currentPage)
      fd.append('pageSize', this.query.pageSize)
      this.$axios.post('https://verify.wespace.cn/gov/retrievePretreatmentListWS', fd).then(res=>{
        this.fullscreenLoading = false
        if (res.data.code == 200) {
          this.tableData = res.data.data
          this.total = res.data.page.totalRows
          console.log(this.tableData)
        } else {
          this.$message(res.data.message)
        }
      }).catch(err=>{
        this.fullscreenLoading = false
        console.log(err)
      });
    },
    //详情
    detailed(row) {
      if(this.query.usn != '' && row.batchNo != '') {
        this.$router.push({
          path: '/copyrightRegistration',
          query: {
            batchNo: row.batchNo,
            showDetails: '1'
          }
        })
      }
    },
    // 查看通过的作品列表
    seeBook(item) {
      if(item.cerPath){
        window.open(this.file_url + item.cerPath, "_blank");
      }else{
        this.$message({
          message: '证书生成中，请稍后',
          type: 'warning'
        });
      }
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getList()
    },
    handleCurrentChange(val) {
      this.query.currentPage = val;
      this.getList()
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-button--primary{
  background-color: #1C77FF;
  border-color: #1C77FF;
}
::v-deep .el-button--text{
  color: #1C77FF;
}
.area{
  display: flex;
  align-items: center;
  margin-bottom: 60px;
  p{
    cursor: pointer;
    line-height: 38px;
    padding: 0 20px;
    background: #1C77FF;
    margin-left: 16px;
    border-radius: 4px;
    color: #fff;
  }
  .icon{
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-left: 10px;
    &.open{
      background: url('../../assets/密码查看@2x.png') left top no-repeat;
      background-size: 100% 100%;
    }
    &.close{
      background: url('../../assets/密码隐藏.png') left top no-repeat;
      background-size: 100% 100%;
    }
  }
  span{
    display: inline-block;
    padding: 0 12px;
    min-width: 228px;
    height: 38px;
    line-height: 38px;
    background: #fff;
    border-radius: 4px;
  }
}
.topBox{
  padding-bottom: 20px;
  border-bottom: 1px solid #F7F8FA;
  .topTitle{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    line-height: 24px;
  }
}
.medium{
  text-align: right;
  font-size: 12px;
  margin-bottom: 10px;
}
::v-deep .el-pagination{
  text-align: right;
  margin-top: 20px;
}
::v-deep .el-table__header-wrapper{
  background-color: #F7F8FA;

}
::v-deep .el-icon-plus{
  position: relative;
  top: -10px;
  color: #FFFFFF;
  margin-right: 5px;
  margin-left: -5px;
}
::v-deep .medium .el-button--medium{
    width: 102px !important;
    height: 28px !important;
    background: #1C77FF !important;
    border: 1px solid #1C77FF !important;
    opacity: 1;
    span{
      position: relative;
      top: -10px;
      left: 0px;
      font-size: 12px;
      margin: 0 auto;
      color: #FFFFFF;
      text-align: center;
      line-height: 28px;
      img{
        width: 12px;
        height: 12px;
        // margin-top: 1px;
      }
    }
  }
.overall-situation{
  height: calc(100vh - 160px);
  overflow-y: auto;
  .situation{
    margin: 0 auto;
    min-width: calc(100% - 40px);
    max-width: calc(100% - 40px);
    padding: 20px 0;
    padding-right: 20px;
    margin-left: 20px;
    background: #FFFFFF;
  }
  .statesBox {
    display: flex;
    justify-content: center;
    div {
      width: 80px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .states {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 8px;
        float: left;
    }
    .statesAdopt {
        //状态-通过
        background: #2DA55D;
    }
    .statesFail {
        //状态-不通过
        background: #E05F42;
    }
    .statesSubmit {
        //状态-待提交
        background: #954EFF;
    }
    .statesReviewed {
        //状态-待审核
        background: #4E77FF;
    }
    .statesConduct{
        //状态-待审核
        background: #FFC300;
    }
  }
}

</style>
